import { useState } from "react";
import { motion } from "framer-motion";
import { ShieldCheck } from "lucide-react";

export const AgeGate = () => {
  const [verified, setVerified] = useState(() => localStorage.getItem("ap_age_verified") === "1");
  const [denied, setDenied] = useState(false);

  if (verified) return null;

  return (
    <div className="fixed inset-0 z-[200] flex items-center justify-center bg-[#05060A] px-5" data-testid="age-gate">
      <motion.div
        initial={{ opacity: 0, scale: 0.94, y: 16 }}
        animate={{ opacity: 1, scale: 1, y: 0 }}
        transition={{ duration: 0.45, ease: [0.22, 1, 0.36, 1] }}
        className="glass w-full max-w-md rounded-2xl p-8 text-center"
      >
        <img src="/assets/logo.webp" alt="Alpha Peps logo" className="mx-auto h-14 w-auto" />
        <div className="mt-6 flex items-center justify-center gap-2 font-mono text-[10px] tracking-[0.3em] text-[#E8E9EB]">
          <ShieldCheck className="h-4 w-4" /> AGE VERIFICATION
        </div>
        <h2 className="mt-3 font-display text-2xl font-bold tracking-tight text-white">Are you 18 or older?</h2>
        <p className="mt-3 text-sm leading-relaxed text-slate-400">
          This website sells laboratory research products intended for adults aged 18 years and over only.
        </p>
        {denied ? (
          <p className="mt-6 rounded-xl border border-red-400/25 bg-red-400/10 px-4 py-3 text-sm text-red-400" data-testid="age-gate-denied">
            You must be 18 or older to view this website.
          </p>
        ) : (
          <div className="mt-6 flex flex-col gap-3">
            <button
              onClick={() => { localStorage.setItem("ap_age_verified", "1"); setVerified(true); }}
              data-testid="age-gate-confirm"
              className="w-full rounded-full bg-[#E8E9EB] py-3.5 font-mono text-xs tracking-[0.25em] text-[#050811] transition-colors duration-200 hover:bg-white"
            >
              I AM 18 OR OLDER - ENTER
            </button>
            <button
              onClick={() => setDenied(true)}
              data-testid="age-gate-deny"
              className="w-full rounded-full border border-white/10 py-3.5 font-mono text-xs tracking-[0.25em] text-slate-400 transition-colors duration-200 hover:border-white/25 hover:text-white"
            >
              I AM UNDER 18
            </button>
          </div>
        )}
      </motion.div>
    </div>
  );
};
